var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h3',[_vm._v("Sorry, page not found")]),_c('img',{attrs:{"width":"300","src":require("@/assets/404nod.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }